// extracted by mini-css-extract-plugin
module.exports = {"cancelledState":"styles__cancelledState___1MQl9","replacementIcon":"styles__replacementIcon___3GlfU"};